module.exports = __webpack_public_path__ + "static/edh-screen1-bacac91fb1aae644fb898cde75875b6d.jpg";